// React 19 hoistet <title>/<meta>/<link> in den <head>. So bleibt die
// Client-Navigation konsistent zum prerenderten HTML (Canonical + OG).
export const Seo = ({ title, description, canonical }) => (
  <>
    <title>{title}</title>
    <meta name="description" content={description} />
    {canonical && <link rel="canonical" href={canonical} />}
    <meta property="og:title" content={title} />
    <meta property="og:description" content={description} />
    {canonical && <meta property="og:url" content={canonical} />}
    <meta property="og:type" content="website" />
  </>
);
